import IntlProvider from './IntlProvider';
import PropTypes from 'prop-types';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';

const Provider = ({ store, children }) => (
    <ReduxProvider store={store}>
        <IntlProvider>{children}</IntlProvider>
    </ReduxProvider>
);

Provider.propTypes = {
    children: PropTypes.element.isRequired,
};

export default Provider;
